export default __webpack_public_path__ + "static/media/erp_v2.3afeeacf.jpg";